import { CustomInput } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { TFormBuilderSingleLineInputField } from '@/types';

type TProps = {
  field: TFormBuilderSingleLineInputField;
};

/**
 * Preview component for single line input field in form builder
 * @param props - Component props
 * @param props.field - Single line input field data to preview
 * @returns Form builder single line input preview component
 */
export const FormBuilderPreviewSingleLineInput = ({ field }: TProps) => {
  const [value, setValue] = useState('');
  return (
    <CustomInput
      labelProps={{ label: field.label, required: field.required }}
      placeholder={field.placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      sx={{ maxWidth: '343px', width: '100%' }}
    />
  );
};
